import * as signalR from '@microsoft/signalr';
import { SIGNALR_HUB_URL } from "./url";

 

  class SignalRService2 {
    constructor() {
      const uid = "?userId=" + encodeURIComponent(JSON.parse(localStorage.getItem("loginUserDetails"))?.uid);

      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(SIGNALR_HUB_URL + uid)
        .withAutomaticReconnect([0, 2000, 5000, 10000]) // Adjusted retry intervals
        .configureLogging(signalR.LogLevel.Information)
        .build();
        this.listeners = {};

        this.connection.on('UpdateMarketList', data => this.handleEvent('UpdateMarketList', data));
        this.connection.on('GetActiveBM', data => this.handleEvent('GetActiveBM', data));
        this.connection.on('GetActiveSession', data => this.handleEvent('GetActiveSession', data));
        this.connection.on('inplaycount', data => this.handleEvent('inplaycount', data));
        this.connection.on('updateNews', data => this.handleEvent('updateNews', data));
        this.connection.on('BetPlacedMessage', data => this.handleEvent('BetPlacedMessage', data));
        this.connection.on('EventSuspended', data => this.handleEvent('EventSuspended', data));
      }
    
      startConnection = async () => {
        if (this.connection.state !== signalR.HubConnectionState.Disconnected) {
          console.error('Connection is not in the Disconnected state');
          return;
        }
    
        try {
          await this.connection.start();
          console.log('SignalR connection established');
        } catch (err) {
          console.error('SignalR connection error:', err);
          setTimeout(this.startConnection, 5000); // Retry connection after 5 seconds
        }
      }
    
      handleEvent = (eventName, data) => {
        if (this.listeners[eventName]) {
          this.listeners[eventName].forEach(callback => callback(data));
        }
      }
    
      addListener = (eventName, callback) => {
        if (!this.listeners[eventName]) {
          this.listeners[eventName] = [];
        }
        this.listeners[eventName].push(callback);
      }
    
      sendEvent = async (eventName, data) => {
        try {
          await this.connection.invoke(eventName, data);
        } catch (err) {
          console.error(`Error sending ${eventName}:`, err);
        }
      }
    }
    
    export default new SignalRService2();